import {Component} from "@angular/core";

@Component({
  selector: 'bn-app-state-couldnt-load',
  templateUrl: './app-state-couldnt-load.component.html',
  styleUrls: ['./app-state-couldnt-load.component.scss', '../bn-app-state-widget.component.scss']
})
export class AppStateCouldntLoadComponent{

}
